import React from "react";
import PropTypes from 'prop-types';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { withStyles } from '@material-ui/core/styles';
import {
    Button,
    CircularProgress,
    Dialog, DialogActions, DialogTitle,
    Grid,
    Tab,
    Tabs
} from '@material-ui/core';
import SearchBar from 'material-ui-search-bar';

//import * as CmsActions from '../actions/CmsActions';
//import * as GlobeActions from '../actions/GlobeActions';
import LayerList from './LayerList';

const styles = theme => ({
    gridContainer: {
        alignItems: 'center',
    },
    tabs: {
        margin: '0 auto',
        maxWidth: '100%',
        fontSize: '0.75rem',
        margin: 'auto 0.875rem',
        height: '2rem',
        '& button': {
            minWidth: "2rem",
        }
    },
    gridOverride: {
        maxWidth: "none",
        flexBasis: "auto"
    }
});

export default class Layers extends React.Component {
    static propTypes = {
        enabledActions: PropTypes.arrayOf(PropTypes.string)
    }
    static defaultProps = {
        enabledActions: [""]
    }
    constructor(props) {
        super(props);
        this.classes = withStyles();
        this.state = { filterTabs: "*", filteredList: [], deletingID: null };
    }
    componentWillMount() {

    }
    componentDidMount() {
        /*if (this.props.visLayers == null && !this.props.fetching) {
            this.props.dispatch(CmsActions.requestVisLayers(this.props.userId));
        } else */if (this.state.filteredList.length != this.props.visLayers) {
            this.setState({ filteredList: this.props.visLayers });
            
        }
    }
    /*componentWillReceiveProps(nextProps) {
        if (nextProps.deleting == false) {
            this.handleDeleteClose();
        }
        
        this.setState({ filteredList: nextProps.visLayers });
    }*/

    componentDidUpdate(prevProps) {
        if (prevProps.deleting && this.props.deleting == false) {
            this.handleDeleteClose();
        }
        if (prevProps.visLayers != this.props.visLayers) {
            //console.log(this.state.filterTabs);
            this.filterList(this.state.filterTabs);
        }
        
    }
    handleLayerToggle(id, isChecked) {
        this.props.handleLayerToggle(id, isChecked);
        //this.props.dispatch(CmsActions.toggleLayer(this.props.userId, id, isChecked));
    }
    handleFlyTo(id) {
        this.props.dispatch(GlobeActions.flyToLocation(id));
    }

    handleDelete(id) {
        this.props.handleDelete(id);
        //this.setState({ dialogOpen: true, deletingID: id });
    }
    handleDeleteConfirm(evt) {
        this.props.dispatch(CmsActions.deleteLayer(this.state.deletingID));
    }
    handleDeleteClose() {
        this.setState({ dialogOpen: false, deletingID: null });
    }
    handleCallToAction(newAppState) {
        this.props.dispatch(CmsActions.changeAppState(newAppState));
    }
    handleStyle(id,style) {
        this.props.handleStyle(id,style);
    }
    handleSave(id,filename) {
        this.props.handleSave(id,filename);
    }
    handleSorted(oldIndex, newIndex) {
        // copy array for immutability
        let sortedArr = this.state.filteredList.slice();
        // re-order to match UI
        sortedArr.splice(newIndex, 0, sortedArr.splice(oldIndex, 1)[0]);
        for (var i = 0; i < sortedArr.length; i++) {
            sortedArr[i].Order = i; //updated the order
        }
        // tell state the order prop changed
        this.setState({ filteredList: sortedArr });
        // tell server to update the order
        this.props.handleSorted(sortedArr);
        //this.props.dispatch(CmsActions.reorderLayer(this.props.userId, this.props.visLayers));
    }
    filterList(str) {
        let filterTabs = str;
        if(str === '*') {
            this.setState({ filterTabs: filterTabs, filteredList: this.props.visLayers });
            return;
        }
        let updatedList = this.props.visLayers;
        updatedList = updatedList.filter(function (item) {
            return item.Name.toLowerCase().search(
                str.toLowerCase()) == -1;
        });
        this.setState({ filterTabs: filterTabs, filteredList: updatedList });
    }
    render() {
        const { fetching, fetched, visLayers } = this.props;
        return (
            <div>
                <Grid container spacing={24} justify="center" className={this.classes.gridContainer}>
                    <Grid className={this.classes.gridOverride} item xs={4}>
                        <h2>myGlobe Layers</h2>
                    </Grid>
                    <Grid item xs={12}>
                        {fetching ?
                            <CircularProgress size={40} />
                            : <LayerList isDocked={this.props.isDocked} visLayers={this.state.filteredList} handleSave={this.handleSave.bind(this)} handleStyle={this.handleStyle.bind(this)} handleFlyTo={this.handleFlyTo.bind(this)} handleToggle={this.handleLayerToggle.bind(this)} handleDelete={this.handleDelete.bind(this)} handleSorted={this.handleSorted.bind(this)} />
                        }
                    </Grid>
                    {
                    /*
                        !fetching && this.props.visLayers && this.props.visLayers.length == 0 ?
                            <Grid item xs={12} style={{textAlign:'center'}}>
                                To get started 
                                <Button dense color="primary" onClick={this.handleCallToAction.bind(this,CmsActions.APP_STATES.DATASETS)}>UPLOAD A DATASET</Button>
                                 then 
                                 <Button dense color="primary" onClick={this.handleCallToAction.bind(this,CmsActions.APP_STATES.VISUALISATION)}>CREATE A VISUALISATION</Button></Grid>
                            : null
                    */
                    }
                </Grid>
                {/*<Dialog open={this.state.dialogOpen} onClose={this.handleRequestClose}>
                    <DialogTitle>{"Are you sure you want to delete this layer?"}</DialogTitle>
                    <DialogActions>
                        <Button onClick={this.handleDeleteClose.bind(this)} color="default" disabled={this.state.deleting}>Cancel</Button>
                        <Button onClick={this.handleDeleteConfirm.bind(this)} color="primary" disabled={this.state.deleting}>Delete</Button>
                    </DialogActions>
                    {this.state.deleting ? <LinearProgress /> : null}
                </Dialog>
                    */}
            </div>
        );
    }
}

/*const mapStateToProps = (store) => {
    return {
        userId: store.cmsReducers.userId,
        fetched: store.cmsReducers.fetched,
        fetching: store.cmsReducers.fetchingVisLayers,
        visLayers: store.cmsReducers.visLayers,
        deleting: store.cmsReducers.deleting,
        running: store.cmsReducers.running
    }
}

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators(CmsActions, dispatch)
});
module.exports = connect(mapStateToProps)(withStyles(styles)(Layers));*/
